import React from 'react';
import { Breadcrumbs } from '@mui/material';
import { Link } from 'react-router-dom';
import { toLower, upperFirst } from 'lodash';
import { PoliceDefaut } from '../helpers/contants';

const Chemin = props => {
  //Breadcrumbs
  // const breadCrumbs = useSelector(state => state.profil.chemin)
  const filterBread = props.breadCrumbs.filter(val => val.nom != null && val.nom !== '');
  return (
    <Breadcrumbs
      separator="/"
      aria-label="breadcrumb"
      className="py-2 mb-2"
      style={{
        border: '',
        fontFamily: PoliceDefaut,
        textDecoration: 'none',
        color: '#134491',
      }}
    >
      {filterBread.map((item, index) => {
        return index >= 2 ? (
          <Link
            key={index}
            className=""
            to={item.url}
            style={{
              textDecoration: 'none',
              color: index !== filterBread.length - 1 ? '#134491' : '#0e71b4',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              display: 'inline-block',
              verticalAlign: 'middle',
              maxWidth: '200px',
            }}
          >
            {upperFirst(item.nom)}
          </Link>
        ) : (
          <Link
            style={{
              textDecoration: 'none',
              color: index !== filterBread.length - 1 ? '#134491' : '#0e71b4',
              display: 'inline-block',
              verticalAlign: 'middle',
              whiteSpace: 'nowrap',
              // textTransform: "capitalize",
            }}
            key={index}
            to={item.url}
          >
            {upperFirst(toLower(item.nom))}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Chemin;
